import { render, staticRenderFns } from "./SendEmailModal.vue?vue&type=template&id=394a23f1&"
import script from "./SendEmailModal.vue?vue&type=script&lang=js&"
export * from "./SendEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports